import React from 'react';
import TopImage from '../img/bg_3.jpg';

const Contacts = () => {
  return (
    <>
        <div className="history-image-wrapper">
        <img src={TopImage} alt="История конкурса" className="history-top-image" />
      </div>
    <div className="contacts-container">
      <h1 className="contacts-title">Контакты</h1>

      <div className="contacts-card">
        <h2 className="contacts-subtitle">Союз Дизайнеров России</h2>
        <p className="contacts-address">
          Россия, 117997, Москва,<br />
          ул. Садовническая, д. 35, офис 460
        </p>

        <div className="contacts-info">
          <p><strong>Телефон:</strong> <a href="tel:+74952257686">+7 495 225 76 86</a></p>
          <p><strong>Email:</strong> <a href="mailto:design_2001@gmail.ru">design_2001@gmail.ru</a></p>
        </div>
      </div>
    </div>
    </>
  );
};

export default Contacts;
